
























































































































































































































































































import Component from "vue-class-component";
import Vue from "vue";
import {
  PolicyDto,
  ListByPolicyIdQuery,
  DepositAccountsDto,
  ClientSelector
} from "@/api/ClientPortalApiClient";

import PolicyRelatedDetails from "./PolicyRelatedDetails.vue";
import { UserStore, LoadingSpinnerService, RoleStore } from "@/store";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import PolicyCardProtection from "@/views/policies/PolicyCardProtection.vue";
import PolicyCardInvestment from "@/views/policies/PolicyCardInvestment.vue";
import PolicyCardPension from "@/views/policies/PolicyCardPension.vue";
import FundTotalPerformanceChart from "@/views/policies/charts/FundTotalPerformanceChart.vue";
import PolicyOverallReturn from "@/views/policies/PolicyOverallReturn.vue";
import BackButton from "@/components/BackButton.vue";
import { Dictionary } from "vuex";
import ProfileWidget from "@/views/users/ProfileWidget.vue";
import PortfolioPerformanceColumnChart from "@/views/policies/charts/PortfolioPerformanceColumnChart.vue";
import FundMixChart from "@/views/policies/charts/FundMixChart.vue";
import FundManagerMixChart from "@/views/policies/charts/FundManagerMixChart.vue";

@Component({
  components: {
    PolicyCardProtection,
    PolicyCardInvestment,
    PolicyCardPension,
    BackButton,
    ProfileWidget,
    FundTotalPerformanceChart,
    PolicyOverallReturn,
    PortfolioPerformanceColumnChart,
    FundMixChart,
    FundManagerMixChart
  }
})
export default class Policies extends Vue {
  private protectionMasters = ["Protection", "Life_Cover", "Income_Protection"];
  private investmentMasters = ["Investments", "Savings"];
  private pensionMasters = ["Pension", "Retirement"];

  private alertService = new AlertService();
  private policies: PolicyDto[] | null = [];
  private deposits: DepositAccountsDto[] | null = [];
  private fundManagerMix: Dictionary<number> | null = null;
  private contactId: number = 0;

  private totalTransfersIn = 0;

  get IsExternalBroker(): boolean {
    return RoleStore.isExternalBroker || RoleStore.isBrokerClient;
  }

  async created() {
    LoadingSpinnerService.Show("Loading portfolio...");

    if (
      RoleStore.isExternalBroker ||
      RoleStore.isAnAdvisor ||
      RoleStore.isClient
    ) {
      this.contactId = parseInt(this.$route.params.contactId);
    } else if (RoleStore.isBrokerClient) {
      this.contactId = UserStore.profileId;
    }

    await this.GetPolicies();

    if (this.IsExternalBroker) {
      this.totalTransfersIn = await ApiFactory.CreateDataClient().externalBroker_GetTotalTransfersIn(
        this.contactId
      );
    }
    LoadingSpinnerService.Hide();
  }

  private async GetPolicies() {
    const api = ApiFactory.CreateDataClient();
    this.policies = await api.policies_GetByContactId(this.contactId);
  }

  private base64ToArrayBuffer(base64: string) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  private async DownloadAssetSchedule() {
    LoadingSpinnerService.Show("Creating asset schedule...");
    try {
      if (!this.contactId) throw new Error("Contact id not valid");
      const api = ApiFactory.CreateDataClient();
      const data = await api.externalBroker_DownloadClientAssetSchedule(
        this.contactId
      );
      if (data.data && data.fileName) {
        var bytes = this.base64ToArrayBuffer(data.data);
        const blob = new Blob([bytes], { type: data.contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = data.fileName;
        link.download = fileName;
        LoadingSpinnerService.Hide();
        link.click();
      }
    } catch (error) {
      LoadingSpinnerService.Failure("Something went wrong. Please try again.");
    }
  }

  get protectionPolicies(): PolicyDto[] {
    if (!this.policies) return [];

    return this.policies
      .filter(
        x =>
          this.protectionMasters.indexOf(
            x.categoryMasterCategoryConstant || ""
          ) > -1
      )
      .sort((a, b) => (a.policyNo || "").localeCompare(b.policyNo || ""));
  }

  get investmentPolicies(): PolicyDto[] {
    if (!this.policies) return [];

    return this.policies
      .filter(
        x =>
          this.investmentMasters.indexOf(
            x.categoryMasterCategoryConstant || ""
          ) > -1
      )
      .sort((a, b) => (a.policyNo || "").localeCompare(b.policyNo || ""));
  }

  get pensionPolicies(): PolicyDto[] {
    if (!this.policies) return [];

    return this.policies
      .filter(
        x =>
          this.pensionMasters.indexOf(x.categoryMasterCategoryConstant || "") >
          -1
      )
      .sort((a, b) => (a.policyNo || "").localeCompare(b.policyNo || ""));
  }

  get totalInvestmentValue(): number {
    return this.investmentPolicies.reduce(
      (a, b) => a + (b.totalFundValue || 0),
      0
    );
  }
  get investmentCalculatePercentage(): number {
    var calcPerc =
      ((this.totalInvestmentValue - this.totalInvestmentPremiumsPaid) /
        this.totalInvestmentValue) *
      100;
    return calcPerc;
  }
  get pensionCalculatePercentage(): number {
    return (
      ((this.totalPensionValue - this.totalPensionPremiumsPaid) /
        this.totalPensionValue) *
      100
    );
  }

  get totalInvestmentPremiumsPaid(): number {
    if (this.IsExternalBroker) {
      return this.totalTransfersIn;
    }

    return this.investmentPolicies.reduce(
      (a, b) => a + (b.totalPremiumsPaid || 0),
      0
    );
  }

  get totalPensionValue(): number {
    return this.pensionPolicies.reduce(
      (a, b) => a + (b.totalFundValue || 0),
      0
    );
  }

  get totalPensionPremiumsPaid(): number {
    return this.pensionPolicies.reduce(
      (a, b) => a + (b.totalPremiumsPaid || 0),
      0
    );
  }

  get clientFullName(): string {
    return UserStore.clientFullName;
  }

  get isAdvisor(): boolean {
    return RoleStore.isAnAdvisor;
  }
  get IsBrokerClient(): boolean {
    return RoleStore.isBrokerClient;
  }
}
